// extracted by mini-css-extract-plugin
export default {"submit-finish-dialog":"loadingModalStyle_m_submit-finish-dialog__i25W8","submit-loading-dialog":"loadingModalStyle_m_submit-loading-dialog__Zn+J-"};